// Currencies that have no minor units in circulation (CLDR cashDigits = 0).
// Intl/ISO reports some of them (e.g. HUF, TWD) with 2 fraction digits,
// so they must be handled explicitly.
export const CURRENCIES_WITHOUT_MINOR_UNITS = new Set([
	'BIF',
	'CLP',
	'DJF',
	'GNF',
	'HUF',
	'ISK',
	'JPY',
	'KMF',
	'KRW',
	'PYG',
	'RWF',
	'TWD',
	'UGX',
	'UYI',
	'VND',
	'VUV',
	'XAF',
	'XOF',
	'XPF'
])

export const getCurrencyFractionDigits = (currencyCode, locale = 'en-US') => {
	if (!currencyCode) {
		return 2
	}
	if (CURRENCIES_WITHOUT_MINOR_UNITS.has(currencyCode)) {
		return 0
	}
	try {
		const formatter = new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: currencyCode
		})
		return formatter.resolvedOptions().maximumFractionDigits
	} catch (_e) {
		return 2
	}
}

export const truncateCurrencyValue = (value, fractionDigits) =>
	fractionDigits === 0 ? Math.trunc(Number(value.toFixed(6))) : value

// Returns the originally-entered amount for a price field from
// currencyHistoryData, but only while it still matches the current
// order-currency value: converting back drifts (200 SEK -> 17.42 EUR ->
// 199.99 SEK). Returns null when there is no match, letting callers fall
// back to a rate-based conversion.
export const resolveHistoricalOriginalAmount = (historyData, { priceAttr, currencyCode, eurValue }) => {
	const entry = historyData?.originals?.find(item =>
		item.priceAttr === priceAttr && item.currencyCode === currencyCode
	)
	return entry && parseFloat(entry.amountInEur) === eurValue ? parseFloat(entry.amount) : null
}
